/* Trappbutiken – varukorgssidan (sections/wubs-cart.liquid), 2026-09-14.
 *
 * Sidan fungerar utan det här skriptet (formulär mot /cart). Med skriptet går antal och "Ta bort"
 * via /cart/change.js, och svaret bär både sidans sektion och varukorgslådan (Section Rendering API)
 * – då följer headerns antal med utan en extra hämtning.
 *
 * ⚠️ Lyssnarna sitter på roten och är DELEGERADE: sektionens innehåll byts ut efter varje ändring.
 * ⚠️ Enter i antalsfältet får inte skicka formuläret – första submit-knappen i formuläret är då
 *    kassaknappen (uppdatera-knappen finns bara i <noscript>).
 */
(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const LADA = 'wubs-cart-drawer';

  function init(root) {
    if (!root || root.dataset.wubsCartReady) return;
    root.dataset.wubsCartReady = '1';
    const sektion = root.dataset.sectionId;
    let upptagen = false;

    const antal = (rad) => parseInt(rad.querySelector('[data-wubs-cart-input]')?.value, 10) || 0;

    function visaFel(text) {
      const fel = root.querySelector('[data-wubs-cart-error]');
      if (!fel) return;
      /* '' = rensa. Fallbacken gällde även det, så "Det gick inte" syntes under varje lyckad ändring. */
      fel.textContent = text === '' ? '' : (text || root.dataset.felText || '');
      fel.hidden = !fel.textContent;
    }

    function byt(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ny = doc.querySelector('[data-wubs-cart]');
      if (ny) root.innerHTML = ny.innerHTML;
    }

    function rendera(data) {
      const html = data && data.sections && data.sections[sektion];
      if (html) byt(html);
      const lada = document.querySelector(LADA);
      const ladHtml = data && data.sections && data.sections[LADA];
      if (lada && ladHtml && typeof lada.render === 'function') lada.render({ sections: { [LADA]: ladHtml } });
    }

    /* Vid ett avvisat antal (t.ex. mer än lagret) står fältet kvar på det kunden skrev – hämta om
       sektionen så att sidan visar det som faktiskt ligger i korgen. */
    async function laddaOm() {
      try {
        const res = await fetch(`${ROOT}cart?section_id=${encodeURIComponent(sektion)}`);
        if (res.ok) byt(await res.text());
      } catch (e) { /* sidan står kvar som den var */ }
    }

    async function andra(rad, qty) {
      if (!rad || upptagen) return;
      upptagen = true;
      root.classList.add('is-busy');
      visaFel('');
      try {
        /* Raden kan bära konfigurationens engångsavgift: då flyttas den till en annan rad, se wubs-cart-drawer.js. */
        const flytt = qty === 0 && window.WubsAvgiftsflytt ? await window.WubsAvgiftsflytt(rad.dataset.key) : null;
        if (flytt && flytt.ny) {
          const lagd = await fetch(`${ROOT}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [flytt.ny] }),
          });
          if (!lagd.ok) {
            await laddaOm();
            visaFel();
            return;
          }
        }
        const res = await fetch(`${ROOT}cart/${flytt ? 'update' : 'change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            ...(flytt ? { updates: flytt.updates } : { id: rad.dataset.key, quantity: qty }),
            sections: [sektion, LADA],
            sections_url: window.location.pathname,
          }),
        });
        const data = await res.json().catch(() => null);
        if (!res.ok || !data || data.status) {
          await laddaOm();
          visaFel(data && (data.description || data.message));
          return;
        }
        rendera(data);
        if (window.WubsKonfigSynk) await window.WubsKonfigSynk();
      } catch (e) {
        const falt = rad.querySelector('[data-wubs-cart-input]');
        if (falt) falt.value = falt.defaultValue;
        visaFel();
      } finally {
        upptagen = false;
        root.classList.remove('is-busy');
      }
    }

    root.addEventListener('click', (e) => {
      const rad = e.target.closest('[data-key]');
      if (!rad) return;
      if (e.target.closest('[data-wubs-cart-minus]')) {
        e.preventDefault();
        andra(rad, Math.max(0, antal(rad) - 1));
      } else if (e.target.closest('[data-wubs-cart-plus]')) {
        e.preventDefault();
        andra(rad, antal(rad) + 1);
      } else if (e.target.closest('[data-wubs-cart-remove]')) {
        e.preventDefault();
        andra(rad, 0);
      }
    });

    root.addEventListener('change', (e) => {
      const falt = e.target.closest('[data-wubs-cart-input]');
      if (falt) {
        /* 🧨 Tomt eller ogiltigt fält är inte noll (2026-11-03): det tog bort raden utan fråga.
           Fältet får tillbaka sitt värde. En skriven nolla tar fortfarande bort raden. */
        const qty = parseInt(falt.value, 10);
        if (!Number.isFinite(qty) || qty < 0) {
          falt.value = falt.defaultValue;
          return;
        }
        andra(falt.closest('[data-key]'), qty);
        return;
      }
      const note = e.target.closest('[data-wubs-cart-note]');
      if (note) {
        fetch(`${ROOT}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value }),
        }).catch(() => {});
      }
    });

    root.addEventListener('keydown', (e) => {
      const falt = e.target.closest('[data-wubs-cart-input]');
      if (falt && e.key === 'Enter') {
        e.preventDefault();
        falt.blur(); // blur ger change om värdet ändrats
      }
    });
  }

  document.querySelectorAll('[data-wubs-cart]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-wubs-cart]')));
})();
